import AddRolesTab from "./sub_tabs/AddRolesTab";
import ViewRolesTab from "./sub_tabs/ViewRolesTab";

const manageRolesRouter = {

  roles: 
  {
    title: 'List',
    element: <ViewRolesTab />
  },

  add_role: 
  {
    title: 'Add Roles',
    element: <AddRolesTab />
  }

}

export default manageRolesRouter;